<template>
  <div class="dialog_warp">
    <div class="dialog_form">
      <div class="title" v-if="contractType==1">租赁账单明细：</div>
      <div class="title" v-else>物业账单明细：</div>
      <el-table class="g-table flex-direction-box" :data="tableList" stripe
                style="width: 100%;overflow: hidden;max-height:100%;" size="mini">
        <template slot="empty">
          <el-button v-if="parkListLoading" type="text" :loading="true">加载中</el-button>
          <span v-if="!parkListLoading">暂无数据</span>
        </template>
        <el-table-column prop="fileSendTypeName" label="区间" show-overflow-tooltip>
          <template slot-scope="scope">
            {{scope.row.startTime}}~{{scope.row.endTime}}
          </template>
        </el-table-column>
        <el-table-column prop="billPayDate" label="付款日" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="billName" label="类型" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="payPrice" label="需付金额" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{scope.row.payPrice}}元</span>
          </template>
        </el-table-column>
        <el-table-column prop="state" label="支付情况" show-overflow-tooltip>
          <template slot-scope="scope">
              <p v-if="scope.row.state==3"  style="color:red;">{{scope.row.state|billState}}</p>
              <p v-else>{{scope.row.state|billState}}</p>
          </template>
        </el-table-column>
      </el-table>

      <div class="text-center" style="margin-top:10px">
        <el-button type="success" size="small" @click="close">完成查看</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import * as global from '../config/mUtils'
  import * as getData from "../service/getData";
  export default {
    data() {
      return {
        info: {},
        fileList: [],
        submitLoading: false,
        conts: '',
        tableList:[],
        parkListLoading:false,
        billStatistics:{},
        contractPriceDecimal:1,
        filters:{
          contractId:'',
          type:'',
        },
      }
    },
    created() {
    },
    mounted() {
      this.filters.contractId = this.contractId;
      this.filters.type = this.contractType;
      this.init();
    },
    computed: {},
    props:['contractId','contractType'],
    methods: {
      close(type) {
        if (type === 1) {
          this.$emit('init')
        } else {
          this.$emit('closeDialog')
        }
      },
      init() {
        getData.billList(this.filters).then(res => {
          this.parkListLoading = false;
          if (res.data.code == "success") {
            this.tableList = res.data.data.data.list;
          }
        }).catch(_ => {
          console.log(_);
          this.parkListLoading = false;
        });
      },
    },
    components: {},
    watch: {},
  }
</script>
<style lang="scss">
.g-contp{
  img{
    width: fit-content;
    max-width: 100%;
  }
}

</style>
<style scoped lang="scss">
  @import '../assets/css/mixin';
  .dialog_warp{
    padding: 0;
    margin:0;
    background: #fff;
  }
  .dialog_form {
    margin:0;
    padding: 10px;
    background: #f2f3f5;
  }
  .title{
    font-size:14px;
  }
  .g-basic-data{
    padding: 20px;
    background: #fff;
    display: flex;
    justify-content: space-between;
  }
  .bill-statistics {
    width: 100%;
    min-height: 90px;
    background: #fff;
    display: flex;
    padding: 20px 0;
    box-sizing: border-box;
    border: 1px solid #e5e5e5;
    margin-bottom: 10px;

    .bill-statistics-item {
      flex: 1;
      height: 100%;
      white-space: nowrap;
      text-align: center;
      border-left: 1px solid #e5e5e5;

      h3 {
        height: 32px;
        font-weight: 700;
        font-size: 16px;
        line-height: 32px;
        color: #333;
      }

      p {
        margin-top: 3px;
        font-size: 14px;
        color: #333;
      }
    }

    .bill-statistics-item:first-child {
      border-left: none;
    }
  }



</style>



// WEBPACK FOOTER //
// src/components/bill-details.vue